import { render, staticRenderFns } from "./searchSuggestJudicialView.vue?vue&type=template&id=1a5afa5f&scoped=true&"
import script from "./searchSuggestJudicialView.vue?vue&type=script&lang=js&"
export * from "./searchSuggestJudicialView.vue?vue&type=script&lang=js&"
import style0 from "./searchSuggestJudicialView.vue?vue&type=style&index=0&id=1a5afa5f&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a5afa5f",
  null
  
)

export default component.exports